module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/pink@2x.png?c7ec3487";